export const API_BASE = process.env.REACT_APP_API_BASE;
export const SHOPIFY_CONTROLLER = 'Shopify';
export const ADMIN_CONTROLLER = 'Admin';
export const APP_NAME = process.env.REACT_APP_APP_NAME;


